import { Box, Label } from '@primer/react';
import { EyeIcon, PencilIcon, TrashIcon, HeartFillIcon, LocationIcon, FilterIcon } from '@primer/octicons-react';
import UserAvatar from '../../components/user-avatar';
import React from 'react';

interface ILiveCheckInHocSinhProps {
    data: any
}

const LiveCheckInHocSinh = ({ data }: ILiveCheckInHocSinhProps) => {
    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: "100px 250px 150px 100px 150px",
                borderBottom: "1px solid",
                borderBottomColor: "border.default",
                justifyContent: "space-between",
                pt: 1,
                pb: 1,
                alignItems: "center"
            }}
            key={data.key}
            className="anim-checkin"
        >
            {/* Left: Avatar + Info */}
            <Box>
                <UserAvatar url={data.image_url} borderRadius='8px' fullName={data.ho_ten} size={'xxxlarge'} />
            </Box>
            <Box>
                <Box sx={{ fontWeight: 600, fontSize: 18, color: "accent.fg", cursor: "pointer" }}>
                    {data.ho_ten}
                </Box>
            </Box>
            <Box>
                <Box sx={{ fontSize: 16, color: "fg.muted", fontWeight: 600, display: "flex", alignItems: "center", gap: 2 }}>
                    {data.ma_hs || "N/A"}
                </Box>
            </Box>
            <Box>
                <Box sx={{ fontSize: 16, color: "fg.muted", fontWeight: 600, display: "flex", alignItems: "center", gap: 2 }}>
                    {data.ten_lop || "N/A"}
                </Box>
            </Box>
            {/* Right: Actions */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 3 }}>
                {!data.gio_diem_danh &&
                    <Label sx={{
                        backgroundColor: "severe.muted", color: "severe.emphasis",
                        borderRadius: 2,
                        fontSize: 16,
                        p: 2
                    }} >
                        Chưa điểm danh
                    </Label>
                }
                {data.gio_diem_danh &&
                    <>
                        {data.is_dang_ky_an ?
                            (
                                <Label sx={{
                                    backgroundColor: "success.subtle", color: "success.emphasis",
                                    borderRadius: 2,
                                    fontSize: 16,
                                    p: 2
                                }}>
                                    {data.gio_diem_danh.substring(0, 8)}
                                </Label>
                            ) : (
                                <Label sx={{
                                    backgroundColor: "danger.muted", color: "danger.emphasis",
                                    borderRadius: 2,
                                    fontSize: 16,
                                    p: 2
                                }}>
                                    {data.gio_diem_danh.substring(0, 8)}
                                </Label>
                            )}
                    </>
                }
            </Box>
        </Box>
    );
};

export default LiveCheckInHocSinh;
